import { getProxyRaw, isProxyRawKey } from '../checkers'
import {
  defineProperty,
  getOwnPropertyDescriptor,
  isArray,
  keys
} from '../shortcut'
import { isPrivateKey } from './isPrivateKey'
import { isTerminateValue } from './isTerminateValue'

import type { TRecord } from '../types'

const readonlyMap = new WeakMap()

const handler: ProxyHandler<TRecord> = {
  defineProperty(target, key, descriptor) {
    if (isPrivateKey(key)) defineProperty(target, key, descriptor)
    return true
  },
  deleteProperty(target, key) {
    if (isPrivateKey(key)) delete target[key as keyof typeof target]
    return true
  },
  get(target, key) {
    if (isProxyRawKey(key)) return getProxyRaw(target)
    const value = target[key]
    if (isPrivateKey(key)) return value
    return toReadonly(value)
  },
  getOwnPropertyDescriptor(target, key: string | symbol) {
    if (isPrivateKey(key)) return
    return getOwnPropertyDescriptor(target, key)
  },
  has(target, key) {
    if (isPrivateKey(key)) return false
    return key in target
  },
  ownKeys(target) {
    const ownKeys = keys(target)
    if (isArray(target)) ownKeys.push('length')
    return ownKeys.filter((key) => !isPrivateKey(key))
  },
  set(target, key, value) {
    if (isPrivateKey(key)) target[key as keyof typeof target] = value
    return true
  }
}

export function toReadonly<T>(target: T): T {
  if (!target || isTerminateValue(target)) return target
  const cached = readonlyMap.get(target)
  if (cached) return cached
  const proxy = new Proxy(target, handler)
  readonlyMap.set(target, proxy)
  return proxy
}
